import { render, staticRenderFns } from "./Accessibilita_body.vue?vue&type=template&id=7d1c18d0"
import script from "./Accessibilita_body.vue?vue&type=script&lang=js"
export * from "./Accessibilita_body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports